import { MessageDescriptor } from 'react-intl';
import { EmailTemplateTypes } from '../api/email-templates.dao';

export const emailTemplateTypes: Record<EmailTemplateTypes, MessageDescriptor> = {
    [EmailTemplateTypes.CONNECTION_EMAIL]: {
        id: 'oe.emailTemplates.connectionEmail',
        description: 'Text',
        defaultMessage: 'Connection Email',
    }
};
